<div class="stat">
  <div class="stat-title">{{ indicatorTitle | translate }}</div>
  <div class="stat-subtitle" *ngIf="indicatorSubtitle">{{ indicatorSubtitle | translate }}</div>
  <div class="details" [ngClass]="{ 'not-compared' : !isComparison() }">
    <div class="trend" *ngIf="isComparison()">
      <div class="stat-trend">
        <svg-icon icon="arrow-up-agent-stat" class="arrow-up" [ngClass]="{ 'only-one-arrow-displayed' : isOverPerform }"></svg-icon>
        <svg-icon icon="arrow-up-agent-stat" class="arrow-down" *ngIf="!isOverPerform"></svg-icon>
      </div>
      <div class="stat-numbers" [ngClass]="{ 'over-perform' : isOverPerform }">
        <span class="percentage">{{ getPerformancePercentage() }}</span>
        <span>%</span>
      </div>
    </div>
    <div class="current-value" [ngClass]="{ 'comparison' : isComparison() }">
      <span [ngClass]="{ 'comparison-duration' : isComparison() }">{{ (getIndicatorDuration() | translate) + ' '}}</span>
      <span class="value">{{ getCurrentValue() }}</span>
      <span *ngIf="indicatorUnit">{{ ' ' + (indicatorUnit | translate) }}</span>
    </div>
    <div class="target-value" *ngIf="isComparison()">
      <span *ngIf="indicator.compareToDuration">{{ (getCompareToDuration() | translate) + ' ' }}</span>
      <span *ngIf="indicator.compareToValue">{{ ('agentStats.target' | translate) + ' '}}</span>
      <span class="target">{{ getTargetValue() }}</span>
      <span *ngIf="indicator.compareToDuration && indicatorPostFix">{{ indicatorPostFix | translate }}</span>
    </div>
  </div>
</div>
